import { View } from '../../manager';
import { useGlobalStateRef } from './use-global-state';

const SKIP_LAZY_LOAD_FOR_TYPES = new Set(['frame', 'section', 'image', 'shape', 'text']);

export function useLazyLoadElement(type: string | undefined) {
  const [stateRef] = useGlobalStateRef();

  if (!type || SKIP_LAZY_LOAD_FOR_TYPES.has(type || '')) return false;

  const lazyLoadSettings = stateRef.current.settings?.load;
  return (lazyLoadSettings === 'lazy-ios' && View.isIOS) || lazyLoadSettings === 'lazy';
}
